import { apiUrl } from './config.js';
export const api = {
    searchQuery: `${apiUrl}/search`,
    cities: `${apiUrl}/location/cities`,
    buses: `${apiUrl}/search/buses`,
    busDetails: `${apiUrl}/bus/details`,
    book: `${apiUrl}/booking/pay`,
    paymentVerify: `${apiUrl}/pay/verify`,
    login: `${apiUrl}/login`,
    verifyLogin: `${apiUrl}/login/verify`,
    myBookings: `${apiUrl}/booking/get`,
    refundCalculation: `${apiUrl}/booking/calculate/refund`,
    cancelBooking: `${apiUrl}/booking/cancel`,
    validateCoupon: `${apiUrl}/coupon/validate/`,
    submitReview: `${apiUrl}/review/submit`,
    getReviews: `${apiUrl}/review/get`,
};